export type TypeEstruturas =
	| 'Acesso'
	| 'Crista'
	| 'Talude de montante'
	| 'Talude de jusante'
	| 'Ombreira Direita'
	| 'Ombreira Esquerda'
	| 'Área de justante ao pé da barragem'
	| 'Reservatório'
	| 'Tomada d\'água'
	| 'Vertedouro'
	| 'Sistema de drenagem superficial'
	| 'Drenagem interna / Dreno fundo'
	| 'Instrumentação'
	| 'Sinalização';

export const estruturaTipos: TypeEstruturas[] = [
	'Acesso',
	'Crista',
	'Talude de montante',
	'Talude de jusante',
	'Ombreira Direita',
	'Ombreira Esquerda',
	'Área de justante ao pé da barragem',
	'Reservatório',
	'Tomada d\'água',
	'Vertedouro',
	'Sistema de drenagem superficial',
	'Drenagem interna / Dreno fundo',
	'Instrumentação',
	'Sinalização',
];

export const estruturaItensMap: Record<TypeEstruturas, string[]> = {
	Acesso: [
		'Erosões Deslizamentos nas vias',
		'Acúlumo de Água',
		'Defeitos nos dispositivos de drenagem',
		'Defeitos na Sinalização',
		'Restrição nos acessos',
	],
	Crista: [
		'Fissura / Trinca',
		'Ausência de proteção',
		'Subsidências, depressões ou buracos',
		'Erosões ou ravinamentos superficiais',
		'Vegetação arbórea ou arbustiva',
		'Acúmulo de água (Inclinação)',
		'Defeito nos dispositivos de Drenagem',
		'Defeitos na leira',
		'Presença de animais (Formigueiros,tocas,etc.)',
	],
	'Talude de montante': [
		'Erosões ou ravinamentos',
		'Fissura / trinca',
		'Ausência de proteção',
		'Vegetação falha ou crescimento irregular',
		'Rip-Rap danificado ou incompleto',
		'Conformação inadequada',
		'Presença de animais (Formigueiros, tocas, etc.)',
		'Escorregamentos ou abatimentos',
	],
	'Talude de jusante': [
		'Erosões ou ravinamentos',
		'Vegetação falha ou crescimento irregular',
		'Conformação inadequada',
		'Presença de animais (Formigueiros, tocas, etc.)',
		'Escorregamentos ou abatimentos',
		'Áreas úmidas, encharcadas/ fofas ou surgência',
	],
	'Ombreira Direita': [
		'Erosões ou ravinamentos',
		'Desprendimento de blocos',
		'Fraturamento',
		'Deslizamento / rastejo',
		'Vegetação densa',
		'Áreas úmidas, encharcadas / fofas ou surgências',
		'Alteração no solo / rocha',
		'Presença de animais (Formigueiros, tocas, etc)',
		'Movimento de massas dos taludes',
	],
	'Ombreira Esquerda': [
		'Erosões ou ravinamentos',
		'Desprendimento de blocos',
		'Fraturamento',
		'Deslizamento / rastejo',
		'Vegetação densa',
		'Áreas úmidas, encharcadas / fofas ou surgências',
		'Alteração no solo / rocha',
		'Presença de animais (Formigueiros, tocas, etc)',
		'Movimento de massas dos taludes',
	],
	'Área de justante ao pé da barragem': [
		'Erosões ou ravinamentos',
		'Desprendimento de blocos',
		'Fraturamento',
		'Deslizamento / rastejo',
		'Vegetação densa',
		'Áreas úmidas, encharcadas/fofas ou surgências',
		'Alteração no solo / rocha',
		'Presença de animais (Formigueiros, tocas, etc)',
		'Movimento de massas dos taludes',
	],
	Reservatório: [
		'Praia inadequada',
		'Borda livre insuficiente',
		'Deslizamento / desmoronamento nas margens',
		'Assoreamento',
		'Presença de animais (Formigueiros, tocas, etc.)',
		'Vegetação flutuante em excesso',
		'Troncos de árvores',
	],
	'Tomada d\'água': [
		'Trincas ou Fissuras',
		'Desplacamento ou foliações',
		'Infiltrações',
		'Ferragem exposta',
		'Obstrução',
		'Reação Álcali-Agregado (RAA)',
		'Ausência de boias de sinalização próximo à tomada',
	],
	Vertedouro: [
		'Trincas ou Fissuras',
		'Desplacamento ou foliações',
		'Infiltrações',
		'Deslocamentos',
		'Turbidez elevada',
		'Ferragem exposta',
		'Obstrução',
		'Reação Álcali-Agregado (RAA)',
		'Necessidade de Limpeza',
	],
	'Sistema de drenagem superficial': [
		'Canaletas danificadas / obstruídas',
		'Escada descida d\'água danificada',
		'Caixa de passagem assoreada',
		'Caixa de passagem danificada',
		'Canal periférico danificado/ obstr.',
		'Surgência (especificar estrutura)',
		'Erosão (especificar estrutura)',
		'Canais periféricos',
	],
	'Drenagem interna / Dreno fundo': [
		'Carreamento de finos',
		'Turbidez elevada',
		'Bacia de dissipação assoreada',
		'Dreno afogado',
		'Presença de ferro bactérias',
	],
	Instrumentação: [
		'Acessos precários',
		'Ausência de instrumentos',
		'Falta de proteção dos instrumentos',
		'Instrumento sem identificação',
		'Régua linimétrica ilegível',
		'Régua linimetrica não instalada',
		'Defeitos nos piezômetros',
		'Defeitos nos indicadores de nível d\'água',
		'Defeitos nos poços de alívio',
		'Defeitos nos medidores de vazão',
		'Defeitos nos marcos superficiais/ def. condutos',
		'Defeitos nas placas de recalque',
		'Defeitos nos inclinômetros',
		'Defeitos nas caixas suecas',
		'Defeitos na célula de pressão total',
	],
	Sinalização: [
		'Placa tombada',
		'Ausência de placa de identificação',
		'Identificação ilegível',
		'Ausência de placas de rota de fuga',
	],
};
